import COUNTRIES from '../countries.translations'

import translations from './niobium.content'
import type { Metal } from './types'

const t = translations
const dir = '/mine-my-phone/images/metals/niobium'

export const niobium: Metal = {
  id: 29,
  slug: 'niobium',
  name: t.name,
  symbol: 'Nb',
  // Coordinates geocoded from the sheet's place names.
  mines: [
    {
      name: 'Araxá, niobium mine (Brazil)',
      region: t.mine0Region,
      slug: 'araxa',
      coordinates: [-46.94, -19.59],
    },
    {
      name: 'Ouvidor, niobium mine (Brazil)',
      region: t.mine1Region,
      slug: 'ouvidor',
      coordinates: [-47.83, -18.23],
    },
    {
      name: 'Saint-Honoré, niobium mine (Canada)',
      region: t.mine2Region,
      slug: 'saint-honore',
      coordinates: [-71.08, 48.53],
    },
    {
      name: 'Catalão, niobium mine (Brazil)',
      region: t.mine3Region,
      slug: 'catalao',
      coordinates: [-47.95, -18.17],
    },
    {
      name: 'Lovozero, niobium mine (Russia)',
      region: t.mine4Region,
      slug: 'lovozero',
      coordinates: [35.02, 68.01],
    },
  ],
  countries: [
    { name: COUNTRIES.brazil, percent: 92.7 },
    { name: COUNTRIES.canada, percent: 6.1 },
    { name: COUNTRIES.democraticRepublicCongo, percent: 0.7 },
    { name: COUNTRIES.russia, percent: 0.3 },
    { name: COUNTRIES.rwanda, percent: 0.2 },
  ],
  content: {
    smartphone: {
      quantityScore: 1,
      quantityLabel: t.smartphone.label,
      parts: ['screen', 'electronics'],
    },
    whatItDoes: t.whatItDoes,
    extraction: t.extraction,
    quickFact: t.quickFact,
    impacts: {
      environmental: { severity: 1, ...t.impacts.environmental },
      human: { severity: 2, ...t.impacts.human },
      geopolitical: { severity: 3, ...t.impacts.geopolitical },
    },
    supplyRisk: { score: 1, ...t.supplyRisk },
    recycling: { score: 1, ...t.recycling },
    footnotes: t.footnotes,
    photos: {
      hero: {
        src: `${dir}/01.jpg`,
        orientation: 'horizontal',
      },
    },
  },
  // Recovered from columbite-tantalite and tin-smelter waste; ~90% ends up in steel.
  related: ['tin', 'iron', 'tantalum'],
}
